import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  const { background, margin, padding, small, isFlex } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section
        className={` Container-block Container-block-pd-${padding}
          ${margin}
          ${background}
        `}
      >
        <div className={`Container ${small ? 'Container-small' : ''} ${isFlex ? 'flex-container' : ''}`}>
          <InnerBlocks />
        </div>
      </section>
    </>
  );
};
